import { render, staticRenderFns } from "./CompleteVerification.vue?vue&type=template&id=6162df51&scoped=true&"
import script from "./CompleteVerification.vue?vue&type=script&lang=ts&"
export * from "./CompleteVerification.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteVerification.vue?vue&type=style&index=0&id=6162df51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162df51",
  null
  
)

export default component.exports